import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  getDocs,
  getDoc,
  deleteDoc,
  updateDoc,
  doc,
  setDoc,
  orderBy,
} from "firebase/firestore"; // Create, Add Collection

const infographModule = {
  namespaced: true,
  state: {
    infographsList: [],
    isLoading: true,
    isFirstLoad: true,
    updateInfograph: {},
  },
  getters: {
    getInfographes: (state) => state.infographsList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Infographs
    // Get All Infographs
    setInfographs: (state, payload) => {
      state.infographsList = payload;
    },
    // Add Infograph
    addInfograph: (state, payload) => {
      if (state.infographsList.length > 0)
        state.infographsList.unshift(payload);
      else state.infographsList = [payload];
    },
    // Update Infograph
    updateInfographById: (state, payload) => {
      let index = state.infographsList.findIndex(
        (e) => e.infograph_id == payload.infograph_id
      );
      state.infographsList[index] = payload;
    },
    // Delete Infograph
    deleteInfograph: (state, payload) => {
      let filtered = state.infographsList.filter(function (value) {
        return value.infograph_id != payload;
      });
      state.infographsList = filtered;
    },
    // get Infograph by id
    getInfographById: (state, payload) => {
      state.updateInfograph = state.infographsList.find(
        (infograph) => infograph.infograph_id == payload
      );
    },
  },
  actions: {
    // Get All Infographs
    async fetchInfographes({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);

      const infographList = await getDocs(
        query(collection(db, "Infograph"), orderBy("created_date", "desc"))
      );
      let infographArray = [];
      if (!infographList.empty) {
        infographList.forEach((doc) => {
          infographArray.push({ ...doc.data(), infograph_id: doc.id });
        });
      } else {
        console.log("No Infograph found");
        infographArray = false;
      }

      commit("setInfographs", infographArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return infographArray;
    },
    // Add Infograph
    async addInfograph({ commit }, payload) {
      const documentReference = doc(collection(db, "Infograph"));
      const infograph = {
        ...payload,
        infograph_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, infograph);
      commit("addInfograph", infograph);
    },
    // Get Infograph by Id
    async getInfographById({ commit }, payload) {
      const infograph = await getDoc(doc(db, "Infograph", payload));
      commit("getInfographById", infograph.data());
      return infograph.data();
    },
    // Update Infograph
    async updateInfographById({ commit }, payload) {
      updateDoc(doc(db, "Infograph", payload.infograph_id), payload);
      commit("updateInfographById", payload);
    },
    // Delete Infograph
    async deleteInfograph({ commit }, payload) {
      deleteDoc(doc(db, "Infograph", payload));
      commit("deleteInfograph", payload);
    },
  },
};

export default infographModule;
